/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Battle_Royale_DescriptionInputs */

const en_map_battle_royale_description = /** @type {(inputs: Map_Battle_Royale_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multi-fleet robustness showcase in a constrained environment.`)
};

const fr_map_battle_royale_description = /** @type {(inputs: Map_Battle_Royale_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démonstration de robustesse multi-flottes en environnement contraint.`)
};

const ms_sg2_map_battle_royale_description = /** @type {(inputs: Map_Battle_Royale_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Demonstrasi keteguhan pelbagai armada dalam persekitaran terhad.`)
};

/**
* | output |
* | --- |
* | "Multi-fleet robustness showcase in a constrained environment." |
*
* @param {Map_Battle_Royale_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const map_battle_royale_description = /** @type {((inputs?: Map_Battle_Royale_DescriptionInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Battle_Royale_DescriptionInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_map_battle_royale_description(inputs)
	if (locale === "fr") return fr_map_battle_royale_description(inputs)
	return ms_sg2_map_battle_royale_description(inputs)
});